// Odeslat komentář

import { FlashMessage } from '@components';
import { prepareFormData } from '@utils/form';
import * as api from './forumApi';
import { forumTimer } from './forumTimer';
import * as Sentry from '@sentry/browser';

interface Message {
  message: string;
  subject: string;
  create_date: string;
  id_message: string;
  id_parent: string;
  id_thread: string;
  id_user: string;
  level: string;
}
interface ResponseSuccess {
  status: boolean | Message;
}

interface ForumSendCommentProps {
  parentCommentId?: string;
  threadId: string;
  content: string;
  notifyEmailRespond: boolean;
}

export const forumSendComment = ({
  parentCommentId = '0',
  threadId,
  content,
  notifyEmailRespond = false,
}: ForumSendCommentProps): void => {
  // Přípravit data
  const requestData = prepareFormData({
    subject: `${parentCommentId === '0' ? 'Přidání' : 'Odpověď'} komentáře`,
    parId: parentCommentId,
    threadId,
    content,
    ajax: '1',
    notify: notifyEmailRespond ? '1' : '0',
  });

  // Odeslat data
  fetch(api.reply(threadId), {
    method: 'POST',
    body: requestData,
  })
    .then((response) => response.json())
    .then(async (data: ResponseSuccess) => {
      if (typeof data.status === 'object') {
        // Informovat uživatele
        await FlashMessage({
          msg: 'Komentář byl přidán.',
          type: 'success',
        });

        // Zapnout časovač
        forumTimer({ init: true });

        // Reloadovat
        const { id_message: commentId } = data.status;
        if (commentId) {
          window.location.href = `${
            window.location.href.split('#')[0]
          }#msg_${commentId.toString()}`;
          window.location.reload();
        }
      } else
        await FlashMessage({
          msg: 'Nepodařilo se odeslat komentář.',
          type: 'error',
        });
    })
    .catch(async () => {
      await FlashMessage({
        msg: 'Nepodařilo se odeslat komentář.',
        type: 'error',
      });
      Sentry.captureException('formSendComment: Operace se nepodařila.');
    });
};
